// extracted by mini-css-extract-plugin
export default {"table-rows":"users_table-rows__t4YXA"};